export default __webpack_public_path__ + "static/media/user.86561052.svg";